import { Balance } from '#/api/balances';

export interface BalanceView {
  readonly id: Balance['token'];
  readonly asset: Balance['token'];
  readonly walletBalance: string;
}

export function balanceView(balance: Balance): BalanceView {
  const id = balance.token;
  const asset = balance.token;
  const walletBalance = walletBalanceView(balance);

  return {
    id,
    asset,
    walletBalance,
  };
}

function walletBalanceView(balance: Balance): string {
  // WIP: format based on asset (the `balance.token`)
  return balance.size.toFormat(2);
}
